import { configureStore } from "@reduxjs/toolkit"
import createSagaMiddleware from "redux-saga"

import rootReducer from "./reducers"
import rootSaga from "./sagas"

const sagaMiddleware = createSagaMiddleware()

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['UPSERT_SUPPORT', 'ADD_SUPPORT_FILE'],
        // Ignore these paths in the state
        ignoredActionPaths: ['payload.formData'],
        // Ignore these paths in all actions
        ignoredPaths: ['supports.formData'],
      },
    }).concat(sagaMiddleware),
  // devTools: process.env.NODE_ENV !== 'production', // optional
})

sagaMiddleware.run(rootSaga)

export default store
